module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-width-1-1"
  }, [_c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1",
    attrs: {
      "uk-grid": ""
    }
  }, [(_vm.page.ShopPage.description && _vm.page.ShopItems.current === 1) ? _c('div', [_c('div', {
    staticClass: "uk-card uk-card-body uk-card-default",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('article', {
    staticClass: "uk-article uk-text-small"
  }, [(_vm.pageImage) ? _c('div', {
    staticClass: "uk-flex uk-flex-center uk-flex-middle"
  }, [_c('div', {
    staticClass: "uk-position-relative"
  }, [_c('img', {
    staticClass: "step-down-transformer-icon",
    attrs: {
      "src": _vm.pageImage.src,
      "alt": _vm.pageImage.description
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "step-down-transformer-first"
  }, [_vm._v("220")]), _vm._v(" "), _c('div', {
    staticClass: "step-down-transformer-second"
  }, [_c('p', [_vm._v(_vm._s(_vm.pageImage.title))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.ShopPage.description)
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('shop-products', {
    attrs: {
      "shop-items": _vm.page.ShopItems,
      "shop-item-prices": _vm.page.ShopItemPrices,
      "shop-items-related": _vm.page.ShopItemsRelated,
      "shop-item-properties": _vm.page.ShopItemProperties,
      "shop-item-warehouses": _vm.page.ShopItemWarehouses,
      "shop-item-tags": _vm.page.ShopItemTags,
      "shop-order-items": _vm.page.ShopOrderItems
    },
    on: {
      "load-page": _vm.loadPage,
      "buy-shop-item": _vm.buy
    }
  }), _vm._v(" "), (_vm.page.ShopPage.text) ? _c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "uk-card uk-card-body uk-card-default"
  }, [_c('article', {
    staticClass: "uk-article uk-text-small",
    domProps: {
      "innerHTML": _vm._s(_vm.page.ShopPage.text)
    }
  })])])]) : _vm._e()], 1)]), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading,
      "loader-class": "tm-loader-wrapper",
      "label": ""
    }
  }, [_c('template', {
    slot: "loading-spinner"
  }, [_c('div', {
    attrs: {
      "uk-spinner": "ratio: 2"
    }
  })])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5c61fd4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/ShopSDTransformerPage.vue
// module id = 158
// module chunks = 0